import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import StarDealCard from 'Components/Cards/StarDealCard';

const HomePageDealContainer = ({ blog, hideTitle, starDealCardNameTag }) => {
  const starDeal = useSelector(state => state.starDeal);

  if (!starDeal || starDeal?.sold_out) return false;

  return (
    <div className="mt-4 mt-lg-0 featured-deal-container">
      {!blog && !hideTitle &&
      <h2 className="mb-3">
        <FormattedMessage id="home.featured_header" defaultMessage="Featured Deal" />
      </h2>
          }
      <StarDealCard
        lightTheme={blog}
        starDealCardNameTag={starDealCardNameTag}
        starDeal={starDeal}
      />
    </div>
  );
};

HomePageDealContainer.propTypes = {
  blog: PropTypes.bool,
  hideTitle: PropTypes.bool,
  starDealCardNameTag: PropTypes.string,
};

HomePageDealContainer.defaultProps = {
  blog: false,
  hideTitle: false,
  starDealCardNameTag: 'h3',
};

export default HomePageDealContainer;
